var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collection-dashboard" },
    [
      _c("div", { staticClass: "hero" }, [
        _c("div", { staticClass: "hero-copy" }, [
          _c("span", { staticClass: "hero-mark" }, [_vm._v("FM")]),
          _c("div", [
            _c("div", { staticClass: "eyebrow" }, [
              _vm._v("FM OPERATIONS CONTROL TOWER"),
            ]),
            _c("h1", [
              _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.pageTitle"))),
            ]),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("collectionOperationDashboard.pageSubtitle"))
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "hero-meta" }, [
          _c("span", { staticClass: "updated" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("collectionOperationDashboard.dataUpdatedAt")) +
                " " +
                _vm._s(_vm.updatedTime) +
                " "
            ),
          ]),
          _c("span", { staticClass: "sp-badge" }, [
            _vm._v(
              _vm._s(_vm.$t("collectionOperationDashboard.coverageBadge"))
            ),
          ]),
        ]),
      ]),
      _c(
        "section",
        { staticClass: "filters" },
        [
          _c("div", { staticClass: "filter-head" }, [
            _c("div", { staticClass: "filter-title" }, [
              _c("span", { staticClass: "filter-symbol" }, [_vm._v("⌁")]),
              _c("div", [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("collectionOperationDashboard.filterTitle"))
                  ),
                ]),
                _c("small", [
                  _vm._v(
                    _vm._s(_vm.$t("collectionOperationDashboard.filterDesc"))
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "quick" },
              _vm._l(_vm.quickRanges, function (item) {
                return _c(
                  "el-button",
                  {
                    key: item.value,
                    class: { active: _vm.quickRange === item.value },
                    attrs: { size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRange(item.value)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.label) + " ")]
                )
              }),
              1
            ),
          ]),
          _c(
            "el-form",
            {
              staticClass: "filter-grid",
              attrs: { model: _vm.filters, "label-position": "top" },
            },
            [
              _c(
                "div",
                { staticClass: "date-range" },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.$t("collectionOperationDashboard.timeLabel"))
                    ),
                  ]),
                  _c("el-date-picker", {
                    attrs: {
                      "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                      "range-separator": _vm.$t("GlobalSetObj.to"),
                      "start-placeholder": _vm.$t("GlobalSetObj.startDate"),
                      size: "small",
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.filters.dateRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "dateRange", $$v)
                      },
                      expression: "filters.dateRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("GlobalSetObj.client") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t(
                          "collectionOperationDashboard.allClients"
                        ),
                        clearable: "",
                        filterable: "",
                        size: "small",
                      },
                      model: {
                        value: _vm.filters.client,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "client", $$v)
                        },
                        expression: "filters.client",
                      },
                    },
                    _vm._l(_vm.clientOptions, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("GlobalSetObj.serviceTypes") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t(
                          "collectionOperationDashboard.allServices"
                        ),
                        clearable: "",
                        filterable: "",
                        size: "small",
                      },
                      model: {
                        value: _vm.filters.service,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "service", $$v)
                        },
                        expression: "filters.service",
                      },
                    },
                    _vm._l(_vm.serviceOptions, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "UF" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t(
                          "collectionOperationDashboard.allUf"
                        ),
                        clearable: "",
                        filterable: "",
                        size: "small",
                      },
                      model: {
                        value: _vm.filters.uf,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "uf", $$v)
                        },
                        expression: "filters.uf",
                      },
                    },
                    _vm._l(_vm.ufOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.label, value: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("collectionCenter.city") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        loading: _vm.cityLoading,
                        placeholder: _vm.$t(
                          "collectionOperationDashboard.cityPlaceholder"
                        ),
                        "remote-method": _vm.handleCitySearch,
                        clearable: "",
                        filterable: "",
                        remote: "",
                        size: "small",
                      },
                      model: {
                        value: _vm.filters.city,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "city", $$v)
                        },
                        expression: "filters.city",
                      },
                    },
                    _vm._l(_vm.cityOptions, function (group) {
                      return _c(
                        "el-option-group",
                        {
                          key: group.label,
                          attrs: { label: _vm.cityGroupLabel },
                        },
                        _vm._l(group.options, function (item) {
                          return _c("el-option", {
                            key: group.label + "-" + item.cityName,
                            attrs: {
                              label: item.cityName,
                              value: item.cityName,
                            },
                          })
                        }),
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "HUB" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t(
                          "collectionOperationDashboard.allHub"
                        ),
                        clearable: "",
                        filterable: "",
                        size: "small",
                      },
                      model: {
                        value: _vm.filters.hub,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "hub", $$v)
                        },
                        expression: "filters.hub",
                      },
                    },
                    _vm._l(_vm.hubOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.handleQuery },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.search")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleReset },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.reset")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BrazilMap", { ref: "brazilMapRef", attrs: { filters: _vm.filters } }),
      _c("CollectionOverview", {
        ref: "collectionRef",
        attrs: { filters: _vm.filters },
        on: { "time-update": _vm.handleTimeUpdate },
      }),
      _c("UfPerformance", { ref: "ufRef", attrs: { filters: _vm.filters } }),
      _c("CityDetail", { ref: "cityRef", attrs: { filters: _vm.filters } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }